(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-back-navigation"] && !Shopify.designMode) return;
  try {
    const mobileBackButton = document.querySelector('[data-mobile-back-button]');

  if (mobileBackButton) {
    mobileBackButton.addEventListener('click', () => {
      const fallbackUrl = mobileBackButton.dataset.fallbackUrl || '/collections/all';
      let hasInternalPreviousPage = false;

      try {
        const referrerUrl = new URL(document.referrer);
        hasInternalPreviousPage =
          referrerUrl.origin === window.location.origin && referrerUrl.href !== window.location.href;
      } catch {
        hasInternalPreviousPage = false;
      }

      if (hasInternalPreviousPage && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.assign(fallbackUrl);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
